import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

export function getAllSurveys(isClosed?: boolean): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Surveys/GetAllSurveys`, {
    params: {
      isClosed: isClosed
    },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}


export function getAllQuestionFormats() {
  return axiosInstance.get(`Surveys/ListQuestionFormats`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getSurveysByUser(userId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Surveys/GetSurveysByUser/${userId}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}


export function registerSurvey(surveyData: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post(`Surveys/RegisterSurvey`, surveyData, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getResponseBySurvey(
  surveyId: number, 
  page?: number, 
  pageSize?: number
): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Surveys/GetResponseBySurvey/${surveyId}`, {
    params: {
      page: page,
      pageSize: pageSize
    },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}


export function softDeleteSurvey(surveyId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Surveys/SoftdeleteSurvey/${surveyId}`, {}, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export const downloadFinishedSurveys = async (): Promise<AxiosResponse<any, any>> => {
  return axiosInstance.get(`Surveys/DownloadFinishedSurveys`, {
    responseType: 'blob', 
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  });
};

export const downloadResponsesSurvey = async (surveyId: number): Promise<AxiosResponse<any, any>> => {
  return axiosInstance.get(`Surveys/DownloadResponsesSurvey/${surveyId}`, {
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  });
};

export function getSurveyById(surveyId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Surveys/GetSurvey/${surveyId}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function respondSurvey(responseData: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post(`Surveys/RespondSurvey`, responseData, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function updateSurvey(surveyId, surveyData) {
  return axiosInstance.put(`Surveys/UpdateSurvey/${surveyId}`, surveyData, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}


export function getUsersForAssigned(name?: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Surveys/GetUsersForAssigned`, {
    params: {
      name: name
    },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function assignedUsersToSurvey(surveyId: number, userIds: number[]): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post(`Surveys/AssignedUsersToSurvey/${surveyId}`, {
    userIds: userIds
  }, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getClosedSurveys(
  page?: number, 
  pageSize?: number, 
  search?: string
): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Surveys/GetClosedSurveys`, {
    params: {
      page: page,
      pageSize: pageSize,
      search: search
    },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getCountSurveysToUser(userId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Surveys/GetCountSurveysToUser/${userId}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function closeSurvey(surveyId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Surveys/ClosedSurvey/${surveyId}`, {}, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function sendSurveysPendingEmail(): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post(`Surveys/SendSurveysPendingEmail`, {}, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getUsersFromExcel(file: File): Promise<AxiosResponse<any, any>> {
  const formData = new FormData();
  formData.append('file', file);
  
  return axiosInstance.post(`Surveys/UsersForSurvey`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export const downloadUsersTemplate = async (): Promise<AxiosResponse<any, any>> => {
  return axiosInstance.get(`Surveys/GetExcelUsersForSurvey`, {
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  });
};

export function sendSurveyReminder(surveyIds: number[], testMode: boolean = true): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post(`Surveys/SendSurveyReminder`, surveyIds, {
    params: {
      testMode: testMode
    },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getUsersByExcel(file: File): Promise<AxiosResponse<any, any>> {
  const formData = new FormData();
  formData.append('file', file);
  
  return axiosInstance.post(`Surveys/ListUserSuppliersByExcel`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}